import Axios from 'api/client';
import { Chapter } from 'types/domain';
import { PaginatedData } from 'types/pagination';

interface AddChapterDialogFormValues {
    name: string;
    members: string;
    role: string;
    schoolId: number | string | null;
    schoolName: string;
    //
    isPartOfSchool?: boolean;
}

const getChapters = (accountId: number, params: { page?: number; query?: string }) =>
    Axios.get<PaginatedData<Chapter>>(`accounts/${accountId}/chapters`, { params }).then(
        response => response.data,
    );

const deleteChapter = (accountId: number, chapterId: number) =>
    Axios.post(`/accounts/${accountId}/chapters/actions`, {
        action: 'DELETE',
        resources: [chapterId],
    }).then(response => response.data);

const createChapter = (accountId: number, formValues: AddChapterDialogFormValues) =>
    Axios.post(`/accounts/${accountId}/chapters/actions`, {
        action: 'CREATE',
        resources: [formValues],
    }).then(response => response.data);

const getSearchSchoolResults = (value: string) =>
    Axios.get(`/schools/search?query=${value}`).then(response => response.data);

export { getChapters, deleteChapter, createChapter, getSearchSchoolResults };

export type { AddChapterDialogFormValues };
